// components/receptionist/PaymentModal.jsx - UPDATE

const PaymentModal = ({ show, onHide, paymentData, setPaymentData, onSubmit, loading }) => {
  if (!show) return null;

  // ✅ Sanitize number input
  const handleAmountChange = (e) => {
    const value = e.target.value;
    const sanitized = value.replace(/[^0-9.]/g, '');
    const num = parseFloat(sanitized);
    setPaymentData({ ...paymentData, feePaid: isNaN(num) ? '' : sanitized });
  };

  const validMethods = ['cash', 'card', 'online'];
  const handleMethodChange = (e) => {
    const method = e.target.value;
    if (validMethods.includes(method)) {
      setPaymentData({ ...paymentData, method });
    }
  };

  return (
    <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" style={{ borderRadius: "16px", border: "none" }}>
          <div
            className="modal-header"
            style={{
              background: "linear-gradient(135deg, #ffc107 0%, #ff9800 100%)",
              color: "white",
              borderRadius: "16px 16px 0 0",
            }}
          >
            <h5 className="modal-title fw-bold">Record Payment</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onHide}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="mb-3">
              <label className="form-label fw-semibold">Amount Paid (Rs) *</label>
              <input
                type="text"
                className="form-control form-control-lg"
                value={paymentData.feePaid}
                onChange={handleAmountChange}
                placeholder="0"
                style={{ borderRadius: "10px" }}
                maxLength="10"
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">Payment Method</label>
              <select
                className="form-select"
                value={paymentData.method}
                onChange={handleMethodChange}
                style={{ borderRadius: "10px" }}
              >
                <option value="cash">Cash</option>
                <option value="card">Card</option>
                <option value="online">Online Transfer</option>
              </select>
            </div>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-secondary"
              onClick={onHide}
              style={{ borderRadius: "10px" }}
            >
              Cancel
            </button>
            <button
              className="btn btn-warning text-white"
              onClick={onSubmit}
              disabled={loading || !paymentData.feePaid || paymentData.feePaid <= 0}
              style={{ borderRadius: "10px" }}
            >
              Record & Print Receipt
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;